<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="Email reception configuration"
        width="1000px"
        append-to-body
        top="10vh"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules" v-loading="formLoading" @submit.native.prevent label-width="160px" class="pr50">
                <el-form-item label="Reception method：">
                    <el-button type="primary" :disabled="isView">Email</el-button>
                </el-form-item>
                <el-form-item label="Recipient's Email：" prop="direction_email" class="label-required">
                    <el-input v-model="formItem.direction_email" :disabled="isView" placeholder="Support for multiple email boxes, separate each email box with an English comma ','"></el-input>
                </el-form-item>
                <el-form-item label="CC's Email：" prop="email">
                    <el-input v-model="formItem.email" :disabled="isView" placeholder="Support for multiple email boxes, separate each email box with an English comma ','"></el-input>
                </el-form-item>
                <el-form-item label="Email Subject：" prop="title" class="label-required">
                    <el-input v-model="formItem.title" :disabled="isView" placeholder="Please enter an email subject" style="width:400px"></el-input>
                    <el-checkbox v-show="!isSend" v-model="formItem.title_date" true-label="1" :disabled="isView" false-label="0" class="ml10">+Yesterday's date</el-checkbox>
                </el-form-item>
                <el-form-item label="Email body：" class="label-required">
                    <WEditor ref="wEditor" :readOnly="isView" :content="formItem.body"/>
                    <div class="remarks font12px mt10" v-show="!isSend">
                        <p>Note：</p>
                        <div style="overflow: hidden">{__AUTO_FILL_LAST_WEEK_TOTAL__}</div>
                        <p class="remarks_text">This string indicates that the system displays the daily summary information of the corresponding fields specified by the template in the sheet. If this string is removed or the format of the string is inconsistent, the email body will not display the filled content</p>
                    </div>
                </el-form-item>
                <el-form-item label="Whether to send Excel：" class="label-required">
                    <el-radio-group v-model="formItem.is_send" :disabled="isView||isSend">
                        <el-radio label="1">Send</el-radio>
                        <el-radio label="0">Do not send</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Excel sending method：" v-if="formItem.is_send=='1'" class="label-required">
                    <el-radio-group v-model="formItem.send_type" :disabled="isView||isSend">
                        <el-radio label="1">Send as a link
                            <el-tooltip class="item" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>Add a download link in the body, which will prompt to download and save to the local or open online (depending on the browser's properties). The name of the downloaded zip file will take the email subject as its name. It is recommended to use this method to avoid attachment issues causing large emails and to enhance sending speed.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">Send as an attachment
                            <el-tooltip class="item"  placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>Add Excel as an attachment in the email, if the attachment is compressed, the zip file name will take the email subject as its name. This method is not recommended as attachments may cause large emails that cannot be sent and affect loading and sending speed!</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Compress attachment："  v-if="formItem.is_send=='1'&&formItem.send_type=='2'" class="label-required">
                    <el-radio-group v-model="formItem.zip_send" :disabled="isView||isSend">
                        <el-radio label="0">Do not compress</el-radio>
                        <el-radio label="1">Compress</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button v-if="isView" type="primary" @click="handleClose" class="action-btn mr20">Close</el-button>
            <el-button v-if="isSend" type="default" @click="handleClose" class="action-btn mr20">Close</el-button>
            <el-button v-if="isSend" type="primary" @click="sendMail" :loading="sendLoading" class="action-btn mr20">Send</el-button>
        </div>
        <ErrTipModal ref="errTipModal" />
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex'
    import WEditor from '../../../components/editor';
    import ErrTipModal from '../../../modal/errorTipModal';
    import {
        getTemplateRecordEmail,
        getTemplateRecordEmailSend
    } from '@/api/efficiencyToolEn/record.js'
    import { htmlBorder } from '@/utils'
    export default {
        name: "recordInfoModal",
        components:{
            WEditor,
            ErrTipModal,
        },
        props:{
            data:Object,
            type:String,
        },
        data(){
            const direction_email = (rule,value,callback)=>{
                if(!value){
                    callback(new Error("Please enter the recipient's email"));
                }else{
                    let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                    let mailArr = value.replace(/\;/g,",").split(',');
                    if(mailArr.every(item=>reg.test(item))){
                        callback();
                    }else{
                        callback(new Error('Please enter a valid email'));
                    }
                }
            };
            const email = (rule,value,callback)=>{
                if(!value) return callback();
                let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                let mailArr = value.replace(/\;/g,",").split(',');
                if(mailArr.every(item=>reg.test(item))){
                    callback();
                }else{
                    callback(new Error('Please enter a valid email'));
                }
            };
            const title = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:\s?"<>|']/im;
                if(!value){
                    callback(new Error('Please enter an email subject'));
                }else if(value.length>40){
                    callback(new Error('Email subject cannot exceed 40 characters'));
                }else if(reg.test(value)){
                    callback(new Error('Email subject contains illegal characters: /\*:?"<>| [] and spaces'))
                }else{
                    callback();
                }
            };
            return {
                dialogVisible:false,
                formItem:{
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                },
                sendLoading:false,
                formLoading:false,
                rules:{
                    direction_email:[
                        { validator:direction_email ,trigger:'blur'}
                    ],
                    email:[
                        { validator:email, trigger:'blur'}
                    ],
                    title:[
                        {validator:title, trigger:'blur'}
                    ],
                },
            }
        },
        computed:{
            ...mapGetters([
                'name',
                'mobile',
                'email',
            ]),
            isView(){
                return this.type==='view';
            },
            isSend(){
                return this.type==='send';
            },
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formLoading = false;
                this.formItem = {
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                };
                this.$refs.form.resetFields();
            },
            sendMail(){

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = this.data||{};
                        let mailText = this.$refs.wEditor.getContentText();
                        let mailCon = this.$refs.wEditor.getContent();
                        if(mailText.length<=0){
                            return this.$message.error('Please enter email content');
                        }
                        this.sendLoading = true;
                        getTemplateRecordEmailSend({
                            task_record_id:data.task_record_id,
                            direction_email:this.formItem.direction_email.replace(/\;/g,","),
                            email:this.formItem.email.replace(/\;/g,","),
                            title:this.formItem.title,
                            title_date:this.formItem.title_date,
                            body: htmlBorder(mailCon),
                            is_send:this.formItem.is_send,
                            send_type:this.formItem.send_type,
                            zip_send:this.formItem.zip_send,
                        }).then(res=>{
                            console.log('genTask',res);
                            this.$message.success(res.info||'Request successful');
                            this.sendLoading = false;
                            this.$emit('update');
                            this.handleClose();
                        },err=>{
                            console.log('genTask err',err);
                            this.sendLoading = false;
                            if(err.code==403){
                                return this.$message.error(err.info||'Request Error');
                            }

                            let errData = err.data||{};
                            let errList = errData.error_auth||[];
                            if(errList.length>0){
                                this.$refs.errTipModal.showModal({
                                    title:err.info||'The following accounts do not have permission and cannot be sent',
                                    subTitle:'You can confirm the permissions and resend, if you can ignore the files without permission, regenerate and send again',
                                    actionType:'sendTask',
                                    isConfirm:false,
                                    errList:errList,
                                    actionData:'',
                                });
                            }else{
                                this.$message.error(err.info||'Request Error');
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let data = this.data||{};
                    let defaultBody = '<p>Dear all，Attached daily report, please review！</p><p></p><p></p><div>{__AUTO_FILL_LAST_WEEK_TOTAL__}</div><p> </p><p> </p><p>Best Regards<br>' +this.name + '<br>Wanka Huanju | Wanka Online Inc<br>Operations Department </p><p></p><p>Mobile：'+this.mobile +'<br>Email：' + this.email + '<br>Address: 4/F, Building No. B22, Universal Business Park , No.10 Jiuxianqiao Road, Chaoyang District, Beijing, China / 9th Floor, Pacific Insurance Building, Poly Innovator Square, No. 664 Huangpu Avenue Middle, Tianhe District, Guangzhou<br>Wanka Huanju：www.wankacn.com<br>Wanka Online Inc: www.wankaonline.com</p>';

                    if(this.type==='view'){
                        this.formItem.direction_email = data.direction_email.replace(/\;/g,",");
                        this.formItem.email = data.email.replace(/\;/g,",");
                        this.formItem.title = data.title;
                        this.formItem.body = data.body||defaultBody;
                        this.formItem.is_send = data.is_send||'1';
                        this.formItem.send_type = data.send_type||'1';
                        this.formItem.zip_send = data.zip_send||'0';
                        this.formItem.title_date = data.title_date;
                        this.$refs.wEditor.setContent(data.body||defaultBody);
                        this.$refs.wEditor.setDisabled();
                    }else if(this.type==='send'){
                        this.formLoading = true;
                        getTemplateRecordEmail({
                            task_record_id:data.task_record_id,
                        }).then(res=>{
                            this.formLoading = false;
                            let resData = res.data||{};

                            this.formItem.direction_email = resData.direction_email.replace(/\;/g,",");
                            this.formItem.email = resData.email.replace(/\;/g,",");
                            this.formItem.title = resData.title;
                            this.formItem.body = resData.body||defaultBody;
                            this.formItem.is_send = resData.is_send||'1';
                            this.formItem.send_type = resData.send_type||'1';
                            this.formItem.zip_send = resData.zip_send||'0';
                            this.formItem.title_date = resData.title_date;
                            this.$refs.wEditor.setContent(resData.body||defaultBody);
                        },err=>{
                            this.$message.error(err.info||'Request Error');
                            this.formLoading = false;
                            this.handleClose();
                        })
                    }


                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
        &.remarks_text {
            text-indent: 24px;
        }
    }
</style>
